import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import * as firebase from "firebase/app";
import { Router } from "@angular/router";
import { AccountService } from "./../../shared/account/account.service";
import { AuthService } from "./../../shared/services/auth.service";
import { AngularFireAuth } from "angularfire2/auth";

@Component({
  selector: "app-password-reset",
  templateUrl: "./password-reset.component.html",
  styleUrls: ["./password-reset.component.css"]
})
export class PasswordResetComponent implements OnInit {
  isPassResetEmailSent = true;
  passwordResetConfirmMessage: string;

  private authInstance: AngularFireAuth;

  user = {
    email: "",
    password: ""
  };

  constructor(private authService: AuthService, private accountService: AccountService, private router: Router) {
    this.authInstance = this.authService.getAngularFireAuthInstance();
  }

  ngOnInit(): void {
  }

  /**
   * @description allow existing valid user to reset his / her password
   * @returns void
   */
  resetPassword(): void {
    this.authInstance.auth.sendPasswordResetEmail(this.user.email)
      .then(() => {
        this.passwordResetConfirmMessage = "Reset requested. Check your email instructions.";
      })
      .catch(error => {
        this.isPassResetEmailSent = false;
        this.passwordResetConfirmMessage = error.message;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/account/password-reset/password-reset.component.ts